import { ArrowTopRightOnSquareIcon } from "@heroicons/react/20/solid";
import { FC } from "react";

export const Footer: FC = () => {
  return (
    <div className="py-2 mt-16 flex ">
      <p className="reveal-font-body text-xs text-gray-600 pr-2 flex items-center gap-1">
        <a
          href="https://www.reveal.nz/terms-and-conditions"
          target="_blank"
          rel="noreferrer"
        >
          Terms and conditions
        </a>
        <ArrowTopRightOnSquareIcon className="h-4 w-4 fill-gray-400" />
      </p>
      <p className="reveal-font-body text-xs text-gray-600 pl-2 border-l border-l-gray-300 ">
        © Reveal Group Ltd.
      </p>
    </div>
  );
};
